/* ============================================================
   Quiero Rusia · comportamiento del theme
   Menú móvil · buscador (dialog) · favoritos · reveal al scroll ·
   avisos (toast) · alta al carrito por AJAX · galería de la ficha ·
   selector de variantes · cantidad · filtros de colección · copiar enlace.
   ============================================================ */
(function () {
  'use strict';

  /* Con JavaScript activo se esconden los respaldos sin JS */
  document.documentElement.classList.add('qr-js');

  /* ---------- avisos (toast) ---------- */
  const toast = document.querySelector('.qr-toast');
  let toastTimer;
  function aviso(texto) {
    if (!toast) return;
    toast.textContent = texto;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 2800);
  }

  /* ---------- menú móvil ---------- */
  const menuBtn = document.querySelector('.menu-button');
  const nav = document.querySelector('#main-nav');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', () => {
      const abierto = nav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', String(abierto));
    });
    nav.querySelectorAll('a').forEach((a) =>
      a.addEventListener('click', () => {
        nav.classList.remove('open');
        menuBtn.setAttribute('aria-expanded', 'false');
      }),
    );
  }

  /* ---------- buscador (dialog) ---------- */
  const dialog = document.querySelector('.search-dialog');
  const abrirBuscador = document.querySelector('[data-open-search]');
  if (dialog && abrirBuscador) {
    abrirBuscador.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      setTimeout(() => {
        const i = dialog.querySelector('#search-input');
        if (i) i.focus();
      }, 100);
    });
  }

  /* ---------- favoritos (visual) ---------- */
  document.addEventListener('click', (e) => {
    const corazon = e.target.closest('.heart');
    if (!corazon) return;
    e.preventDefault();
    const activo = corazon.classList.toggle('active');
    corazon.setAttribute('aria-pressed', String(activo));
    corazon.textContent = activo ? '♥' : '♡';
  });

  /* ---------- alta al carrito por AJAX ---------- */
  function pintarContador(n) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = n;
    });
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form');
    if (!form || !form.closest('[data-qr-ajax]')) return;
    /* el botón de pago exprés se maneja solo: no lo interceptamos */
    if (e.submitter && e.submitter.dataset && e.submitter.dataset.shopify === 'payment-button') return;
    e.preventDefault();
    const boton = form.querySelector('[type="submit"]');
    const original = boton ? boton.innerHTML : '';
    if (boton) boton.innerHTML = 'AGREGANDO…';
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || 'No se pudo agregar');
      const carrito = await fetch('/cart.js').then((x) => x.json());
      pintarContador(carrito.item_count);
      aviso((data.product_title || 'La pieza') + ' se agregó a tu bolsa');
    } catch (err) {
      aviso('No pudimos agregarlo. Intenta de nuevo.');
    } finally {
      if (boton) boton.innerHTML = original;
    }
  });

  /* ---------- galería de la ficha ---------- */
  const galeria = document.querySelector('[data-qr-galeria]');
  if (galeria) {
    const slides = galeria.querySelectorAll('.qr-galeria-prod__slide');
    const minis = galeria.querySelectorAll('.qr-galeria-prod__mini');
    const activar = (id) => {
      slides.forEach((s) => s.classList.toggle('is-activa', s.dataset.media === id));
      minis.forEach((m) => {
        const activa = m.dataset.media === id;
        m.classList.toggle('is-activa', activa);
        m.setAttribute('aria-selected', String(activa));
      });
    };
    minis.forEach((mini) => mini.addEventListener('click', () => activar(mini.dataset.media)));
  }

  /* ---------- selector de variantes ---------- */
  const selectVariante = document.querySelector('[data-qr-select]');
  const jsonVariantes = document.querySelector('[data-qr-variantes-json]');
  if (selectVariante && jsonVariantes) {
    let variantes = [];
    try {
      variantes = JSON.parse(jsonVariantes.textContent);
    } catch (err) {
      variantes = [];
    }

    const ficha = selectVariante.closest('.qr-prod') || document;
    const grupos = document.querySelectorAll('[data-qr-pills]');
    const elPrecio = ficha.querySelector('[data-qr-precio]');
    const elEstado = ficha.querySelector('[data-qr-estado]');
    const elComprar = ficha.querySelector('[data-qr-comprar]');

    const seleccion = () => Array.from(grupos).map((g) => (g.querySelector('.qr-pill.is-activa') || {}).dataset || { valor: '' }).map((d) => d.valor);

    const buscar = (valores) =>
      variantes.find((v) => v.options.length === valores.length && v.options.every((o, i) => o === valores[i]));

    const pintarEstados = () => {
      grupos.forEach((grupo, indice) => {
        const actuales = seleccion();
        grupo.querySelectorAll('.qr-pill').forEach((pill) => {
          const prueba = actuales.slice();
          prueba[indice] = pill.dataset.valor;
          const existe = variantes.some(
            (v) => v.options.length === prueba.length && v.options.every((o, i) => o === prueba[i]) && v.available,
          );
          pill.classList.toggle('is-agotado', !existe);
        });
      });
    };

    const actualizar = (variante) => {
      if (!variante) return;
      selectVariante.value = String(variante.id);
      if (elPrecio) {
        elPrecio.innerHTML = variante.precio + (variante.comparar ? ' <span class="qr-compare">' + variante.comparar + '</span>' : '');
      }
      if (elEstado) elEstado.textContent = variante.available ? 'DISPONIBLE' : 'AGOTADO';
      if (elComprar) {
        elComprar.disabled = !variante.available;
        elComprar.innerHTML = (variante.available ? 'AGREGAR A LA BOLSA' : 'AGOTADO') + ' <span>＋</span>';
      }
      if (variante.imagen && galeria) {
        const tira = galeria.querySelector('.qr-galeria-prod__principal');
        const slide = galeria.querySelector('[data-media]');
        let objetivo = Array.from(galeria.querySelectorAll('.qr-galeria-prod__slide')).find(
          (s) => s.querySelector('img') && s.querySelector('img').src.split('?')[0].endsWith(variante.imagen.split('?')[0].split('/').pop()),
        );
        if (!objetivo && slide) {
          const nueva = document.createElement('div');
          nueva.className = 'qr-galeria-prod__slide';
          nueva.innerHTML = '<img src="' + variante.imagen + '" alt="" loading="lazy">';
          tira.appendChild(nueva);
          objetivo = nueva;
        }
        if (objetivo) {
          galeria.querySelectorAll('.qr-galeria-prod__slide').forEach((s) => s.classList.toggle('is-activa', s === objetivo));
        }
      }
      if (variante.url && window.history.replaceState) {
        window.history.replaceState({}, '', variante.url);
      }
    };

    grupos.forEach((grupo) => {
      grupo.addEventListener('click', (e) => {
        const pill = e.target.closest('.qr-pill');
        if (!pill || pill.classList.contains('is-agotado')) return;
        grupo.querySelectorAll('.qr-pill').forEach((p) => {
          const activa = p === pill;
          p.classList.toggle('is-activa', activa);
          p.setAttribute('aria-checked', String(activa));
        });
        pintarEstados();
        actualizar(buscar(seleccion()));
      });
    });

    selectVariante.addEventListener('change', () => {
      const v = variantes.find((x) => String(x.id) === selectVariante.value);
      if (!v) return;
      grupos.forEach((grupo, indice) => {
        grupo.querySelectorAll('.qr-pill').forEach((p) => {
          const activa = p.dataset.valor === v.options[indice];
          p.classList.toggle('is-activa', activa);
          p.setAttribute('aria-checked', String(activa));
        });
      });
      pintarEstados();
    });

    pintarEstados();
  }

  /* ---------- cantidad (ficha y bolsa) ---------- */
  document.addEventListener('click', (e) => {
    const menos = e.target.closest('[data-qr-menos]');
    const mas = e.target.closest('[data-qr-mas]');
    if (!menos && !mas) return;
    const caja = e.target.closest('[data-qr-cantidad]');
    const input = caja && caja.querySelector('input');
    if (!input) return;
    const minimo = parseInt(input.min, 10) || 0;
    let valor = parseInt(input.value, 10) || 0;
    valor = mas ? valor + 1 : Math.max(minimo, valor - 1);
    input.value = valor;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- colección: filtros y orden ---------- */
  const formFiltros = document.querySelector('[data-qr-filtros]');
  if (formFiltros) {
    formFiltros.querySelectorAll('[data-qr-autofiltro]').forEach((campo) => {
      campo.addEventListener('change', () => formFiltros.submit());
    });
  }

  const selectOrden = document.querySelector('[data-qr-orden]');
  if (selectOrden && selectOrden.form) {
    selectOrden.addEventListener('change', () => selectOrden.form.submit());
  }

  const panel = document.querySelector('#qr-panel-filtros');
  document.querySelectorAll('[data-qr-abrir-filtros]').forEach((b) =>
    b.addEventListener('click', () => panel && panel.classList.add('is-abierto')),
  );
  document.querySelectorAll('[data-qr-cerrar-filtros]').forEach((b) =>
    b.addEventListener('click', () => panel && panel.classList.remove('is-abierto')),
  );

  /* ---------- copiar enlace ---------- */
  document.addEventListener('click', async (e) => {
    const boton = e.target.closest('[data-qr-copiar]');
    if (!boton) return;
    try {
      await navigator.clipboard.writeText(boton.dataset.qrCopiar);
      aviso('Enlace copiado');
    } catch (err) {
      aviso('Copia el enlace de la barra del navegador');
    }
  });

  /* ---------- reveal al scroll ---------- */
  const elementos = document.querySelectorAll('.reveal');
  if (elementos.length) {
    if (!('IntersectionObserver' in window)) {
      elementos.forEach((el) => el.classList.add('visible'));
    } else {
      const obs = new IntersectionObserver(
        (entradas) => {
          entradas.forEach((ent) => {
            if (ent.isIntersecting) {
              ent.target.classList.add('visible');
              obs.unobserve(ent.target);
            }
          });
        },
        { threshold: 0.12 },
      );
      elementos.forEach((el) => obs.observe(el));
    }
  }
})();
